import React from "react"
import PropTypes from "prop-types"

const SVG = ({ className, size }) => (
  <svg viewBox="0 0 512 512" className={className} {...size}>
    <path
      d="M150.069 0h211.862c9.754 0 17.655 7.901 17.655 17.655v35.31H132.414v-35.31c0-9.754 7.9-17.655 17.655-17.655z"
      fill="#cfcfcf"
    />
    <path
      d="M353.103 79.448V52.966H158.897v26.483c-48.305 21.486-79.439 69.394-79.448 122.262V476.69c0 19.5 15.81 35.31 35.31 35.31h282.483c19.5 0 35.31-15.81 35.31-35.31V201.71c-.009-52.868-31.144-100.775-79.449-122.262z"
      fill="#595959"
    />
    <g fill="#4f4f4f">
      <path d="M353.103 79.448V52.966h-70.621v26.483c48.305 21.486 79.439 69.394 79.448 122.262V476.69c0 19.5-15.81 35.31-35.31 35.31h70.621c19.5 0 35.31-15.81 35.31-35.31V201.71c-.008-52.868-31.143-100.775-79.448-122.262z" />
      <path d="M158.897 52.966h194.207v26.483H158.897z" />
    </g>
    <path fill="#de4c3c" d="M79.448 194.207h353.103v247.172H79.448z" />
    <path
      fill="#fdb62f"
      d="M317.793 300.138h-49.434l14.124-70.621-88.276 88.276h49.434l-14.124 70.621z"
    />
    <path fill="#cfcfcf" d="M432.552 406.069h-70.621V300.138h70.621" />
    <g fill="#bfbfbf">
      <path d="M388.414 361.931h44.138v17.655h-44.138zM388.414 326.621h44.138v17.655h-44.138z" />
    </g>
    <g fill="#8c421c">
      <path d="M353.103 256h79.448v17.655h-79.448zM353.103 220.69h17.655v17.655h-17.655zM388.414 220.69h44.138v17.655h-44.138z" />
    </g>
    <g fill="#cfcfcf">
      <path d="M114.759 370.759h35.31v35.31h-35.31zM114.759 300.138h35.31v35.31h-35.31z" />
    </g>
    <g fill="#8c421c">
      <path d="M123.586 256h35.31v17.655h-35.31zM105.931 220.69h52.966v17.655h-52.966z" />
    </g>
    <path
      d="M361.931 0h-52.966c9.754 0 17.655 7.901 17.655 17.655v35.31h52.966v-35.31c0-9.754-7.9-17.655-17.655-17.655z"
      fill="#bfbfbf"
    />
  </svg>
)

SVG.propTypes = {
  size: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
  }),
}

export default SVG
